//
//
//
//
//
//
//
//
//
//
//
//
//
//

//
import {windVane} from '../../../utils/tmallGenius';
import {tutorialRoute} from '../../../utils/tutorialRoute'
import {queryWifiControllerInfo} from '../../../api'
import {findSupportConnectDevice} from '../../../utils/device/deviceConnect'

export default {
  data() {
    return {};
  },
  beforeRouteEnter(to, from, next) {
    windVane.setNavTitle("添加成功");
    next();
  },
  /*------------------------------------------- 启动运行 -------------------------------------------------------*/
  created() {
    let name = this.$route.query.name;
    if (name === 'allonePro' ||
      name === 'xiaofang' ||
      name === 'xiaoyuan'
    ) { //小方和allonePro有指定跳转
      let uid = sessionStorage.getItem("controllerUid");
      queryWifiControllerInfo({  //查看新添加设备的信息
        token: sessionStorage.getItem("token"),
        uid: uid,
      }).then(res => {
        if (res.status === 0) {
          const device = res.data;
          //设定好后面要跳转的页面
          setTimeout(() => {
            tutorialRoute.set({
              path: '/connect/wifi/select_room',
              query: {
                deviceId: device.deviceId,
                uid: uid,
              },
            });
            this.$router.go(-2); //回到首页，无历史记录
          }, 2000);
        } else {
          alert(JSON.stringify(res))
        }
      }).catch(e => {
        alert(JSON.stringify(e))
      });
    } else {
      setTimeout(() => {
        this.$router.go(-2); //回到首页，无历史记录
      }, 2000);
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/connect/wifi/Done.vue